import { Box } from "@mui/system";
import { Field, reduxForm } from 'redux-form';
import { connect } from "react-redux";
import _ from "lodash";
import { required } from "_helpers";
import BasicFormTextField from "../../../../../../common/BasicFormTextField";
import ActionButton from "../../../../../../common/ActionButton";
import {buildCustomFieldSubmissionFormData} from "./CustomFieldUtils";
import CustomFieldOptionFilterSelect from "./CustomFieldOptionFilterSelect";

function CustomFieldForm({ customFields, filterCustomFieldList, handleCustomFieldFormData, handleSubmit, handleClose }) {
    const customFieldArr = filterCustomFieldList || customFields || [];
    const showForm = !Array.isArray(filterCustomFieldList) || !_.isEmpty(filterCustomFieldList);

    const handleCustomFields = (values) => {
        const customFieldFormData = buildCustomFieldSubmissionFormData(customFieldArr, values);
        handleCustomFieldFormData(customFieldFormData);
        handleClose();
    };

    const renderCustomField = (customField, index) => {
        return (
            <Box key={index}>
                <Box sx={{ mb: '12px' }}>
                    <Box sx={styles.inputDesc}>{customField?.name}{' *'}</Box>
                    <Field
                        name={customField?.name}
                        component={BasicFormTextField}
                        placeholder={`Enter ${customField?.name}`}
                        validate={required}
                    />
                </Box>
            </Box>
        );
    };

    const renderCustomFieldOptions = (customField, customFieldOptions, index) => {
        return (
            <Box key={index}>
                <Box sx={{ mb: '18px' }}>
                    <Box sx={styles.inputDesc}>{customField?.name}{' *'}</Box>
                    <Field
                        name={customField?.name}
                        component={CustomFieldOptionFilterSelect}
                        customFieldOptions={customFieldOptions}
                        validate={required}
                    />
                </Box>
            </Box>
        );
    }

    const EmptyCustomField = () => {
        return (
            <Box>
                <Box sx={styles.body}>
                    {_.isEmpty(customFields)
                        ? 'No custom fields available yet. Try again in a moment.'
                        : 'Custom Fields already attached to chosen Macro'}
                </Box>
                <Box sx={styles.buttonContainer}>
                    <Box>
                        <ActionButton
                            label={'Close'}
                            action={handleClose}
                            withIcon={false}
                            sx={styles.sendButton}
                        />
                    </Box>
                </Box>
            </Box>
        )
    }

    return (
        <>
            {
                showForm ?
                    <form name="form" onSubmit={handleSubmit(handleCustomFields)} autoComplete="off">
                        <Box sx={{ mb: '20px' }}>
                            {customFieldArr.map((customField, index) => {
                                const isRequired = true
                                const customFieldOptions = customField?.customFieldOptions;
                                return customFieldOptions
                                    ? renderCustomFieldOptions(customField, customFieldOptions, index, isRequired)
                                    : renderCustomField(customField, index, isRequired);
                            })}
                        </Box>

                        <Box sx={styles.buttonContainer}>
                            <Box sx={styles.cancelButtonContainer}>
                                <ActionButton
                                    label={'Cancel'}
                                    action={handleClose}
                                    buttonBordered
                                    useBorderColor={'#003300'}
                                    withIcon={false}
                                    sx={styles.cancelButton}
                                    type={'button'}
                                />
                            </Box>
                            <Box>
                                <ActionButton
                                    label={'Add'}
                                    action={handleSubmit(handleCustomFields)}
                                    withIcon={false}
                                    sx={styles.sendButton}
                                />
                            </Box>
                        </Box>
                    </form>
                    : <EmptyCustomField/>
            }
        </>
    );
}

const styles = {
    inputDesc: {
        fontFamily: 'LarsseitMedium',
        fontSize: '14px',
        fontWeight: 500,
        color: '#495D5E',
        mb: '5px',
    },
    body: {
        fontFamily: 'larsseitRegular',
        fontSize: '16px',
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingTop: '15px',
    },
    cancelButtonContainer: {
        width: '84px',
        marginRight: '15px',
    },
    cancelButton: {
        height: '35px',
    },
    sendButton: {
        height: '35px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
};

const validate = (values, { customFields }) => {
    const errors = {};
    if (Array.isArray(customFields)) {
        customFields.forEach(field => {
            if (field.required && !values[field.name]) {
                errors[field.name] = 'This field is required';
            }
        });
    }
    return errors;
};

const mapStateToProps = (state, props) => {
    const initialValues = {};
    const customFields = props.customFields || [];
    const customFieldsInput = props.customFieldsInput || [];
    const fields = customFieldsInput.length ? customFieldsInput : customFields;

    fields.forEach(field => {
        if (field?.value && typeof field.value === 'string') {
            const originalField = customFields.find(customField => customField.name === field.name);
            if (originalField && Array.isArray(originalField.customFieldOptions)) {
                const matchingOption = originalField.customFieldOptions.find(option => option.value === field.value);
                if (matchingOption) {
                    initialValues[field.name] = matchingOption;
                    return;
                }
            }
        }
        initialValues[field?.name] = field?.value || '';
    });

    return { initialValues };
};

CustomFieldForm = reduxForm({
    form: 'CustomFieldForm',
    validate
})(CustomFieldForm);

CustomFieldForm = connect(mapStateToProps)(CustomFieldForm);
export default CustomFieldForm;
